import { TextField, Button, Typography, Container } from '@mui/material';
import React, { useState } from 'react';
import Api from '../../service/Api';
import { useTranslation } from 'react-i18next'; 
import '../Login/Login.css';

function Login() {
  const { t } = useTranslation();
  const [loginData, setLoginData] = useState({
    email: '',
    senha: '',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setLoginData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    try {
       await Api.login(loginData);
       
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data.error;
        window.alert(errorMessage);
      } else {
        console.error('Erro ao enviar dados para a API:', error);
      }
    }
  };


  return (

    <div className="container-login">
    <div className="content-login">
      <Typography variant="h5">Login</Typography>
      <Container>
        <TextField name="email" label="E-mail" fullWidth variant="outlined" margin="normal" onChange={handleChange} />
        <TextField name="senha" label={t('password')} inputProps={{ maxLength: 8 }} fullWidth variant="outlined" type="password" margin="normal" onChange={handleChange} />
        <a href="/forgot-password">{t('login-forgot-password')}</a>
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Button variant="contained" color="primary" style={{width:"150px"}} onClick={handleSubmit} >Login</Button>
        </div>
      </Container>
    </div>
  </div>
  

)}

export default Login;